module.exports = __webpack_public_path__ + "img/Al-haq-Logo-selected.968bc6a0.svg";